import { http } from 'cdui-js';

import { aesEncryptHexByPass } from '../lib/crypto';

export const saveUserSetting = (data) => {
  return http.put(`/user/personalSetting`, data);
};

export const fetchUserSetting = () => {
  return http.get(`/user/personalSetting`);
};

// 修改用户密码
export const updatePwd = async (username, oldPassword, newPassword) => {
  const timestamp = Date.now();

  const key = `${username}${timestamp}`;

  const params = {
    username,
    oldPassword: aesEncryptHexByPass(oldPassword, key),
    newPassword: aesEncryptHexByPass(newPassword, key),
    timestamp,
  };

  const data = await http.post(`/user/updatePassword`, params);
};

// 反馈
interface FeedbackTypes {
  content: string;
  phoneCode?: string;
  phone?: string;
  imgUrls?: string[];
}

// 提交反馈
export const submitFeedback = async (data: FeedbackTypes) => {
  await http.post(`/user/feedback`, data);
};

// 系统公告
export const fetchNotices = async () => {
  const res = await http.get(`/msg/adminNotice/list`);
  return res;
};

// 系统公告详情
export const fetchNoticeDetails = async (id) => {
  const res = await http.get(`/msg/adminNotice/detail/${id}`);
  return res;
};

// 业务消息
export const fetchMsgNotice = async () => {
  const res = await http.get(`/msg/notice/list`);
  return res;
};

// 本设备已保存的账号列表
export const fetchDeviceAccounts = async () => {
  const data = (await http.get(
    `/user/deviceAccount/list?deviceCode=${localStorage.getItem('DIFI_DEVICE_ID') || ''}`
  )) as any;

  return data.map((i) => ({
    name: i.username,
    uid: i.userId,
    id: i.userId,
    ringColor: '#FF5151',
    bgColor: '#FFE5E5',
    initial: i.username.split('')[0],
    isActive: true,
  }));
};

// // 绑定账号
// export const bindDeviceAccount = async () => {
//   const data = await http.post(`/user/deviceAccount/bind`);
// };

// 删除账号
export const removeDeviceAccount = async (targetUserId) => {
  const data = await http.post(`/user/deviceAccount/remove`, {
    deviceCode: localStorage.getItem('DIFI_DEVICE_ID') || '',
    targetUserId,
  });
};

// // 切换账号
// export const switchAccount = async () => {
//   const data = await http.post(`/user/login/switchAccount`);
// };

// 根据/info接口返回的是否设置交易密码safePassword进行调用：
// 设置交易密码：/user/setSafePassword
// "safePassword": "string",
// "validType": "string",
// "verifyCode": "string",
// "username": "string",
// "timestamp": 0
export const setSafePwd = async (safePassword, username) => {
  const timestamp = Date.now();

  await http.post(`/user/setSafePassword`, {
    validType: 1,
    safePassword: aesEncryptHexByPass(safePassword, `${username}${timestamp}`),
    timestamp,
    username,
  });
};

// 修改交易密码：/user/updateSafePassword
export const updateSafePwd = async (oldPassword, newPassword, username) => {
  const timestamp = Date.now();
  const key = `${username}${timestamp}`;
  await http.post(`/user/updateSafePassword`, {
    oldPassword: aesEncryptHexByPass(oldPassword, key),
    newPassword: aesEncryptHexByPass(newPassword, key),
    validType: 1,
    username,
    timestamp,
  });
};

// 合并游客的自选股票：/user/stockFavorite/mergeGuest?deviceCode=
export const mergeGuest = async (deviceCode) => {
  const res = await http.post(`/user/stockFavorite/mergeGuest?deviceCode=${deviceCode}`);
  return res;
};

/** 激活交易品种（仅传要激活的项，勿把另一项传 false） */
export type TradeProductActivationSubmitReq = {
  derivatives?: boolean;
  chinaConnect?: boolean;
};

export const submitTradeProductActivation = (data: TradeProductActivationSubmitReq) => {
  return http.post(`/user/tradeProductActivation/apply/submit`, data) as Promise<void>;
};
